// eslint-disable-next-line import/prefer-default-export
export const openPrintDialog = (blob: Blob): void => {
  window.open(URL.createObjectURL(blob))!.print();
};
